<template>
  <section class="industries-section">
    <div class="container">
      <div class="header">
        <h2>Industries we serve</h2>
        <p>
          For over 10 years, XCL has been making high-quality CNC machined<br>
          parts on demand for industries worldwide.
        </p>
      </div>

      <div class="cards-wrapper">
        <div 
          v-for="(item, index) in industriesData" 
          :key="index" 
          class="card"
        >
          <div class="card-inner">
            <div class="icon-container" v-html="item.iconSvg"></div>
            <h3>{{ item.title }}</h3>
            <p>{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref } from 'vue';

const industriesData = ref([
  {
    title: 'Aerospace',
    desc: 'XCL offers high-temperature alloys CNC and titanium alloys CNC service with thin-walled structures, complex curved surfaces, and extremely high reliability requirements.',
    // 航天飞机
    iconSvg: `<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
  <path d="M0 0h24v24H0z" fill="none" />
  <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m14.134 6.992l3.396-3.397a2.033 2.033 0 0 1 2.875 2.875l-3.397 3.396l1.838 9.145c.235 1.17-2.034 2.8-2.638 1.25l-2.69-6.904l-3.493 3.493c.17 2.041.207 2.72-1.224 4.15l-2.175-3.626L3 15.199c1.43-1.431 2.109-1.395 4.15-1.224l3.493-3.492l-6.904-2.691c-1.55-.604.08-2.874 1.25-2.638z" />
</svg>
`
  },
  {
    title: 'Automotive',
    desc: 'XCL can ensure high-precision CNC machining of lightweight automotive components like sensor housings, connectors and terminals, electrical control system etc.',
    // 汽车轮廓
    iconSvg: `<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
  <path d="M0 0h24v24H0z" fill="none" />
  <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
    <path d="M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2" />
    <circle cx="7" cy="17" r="2" />
    <path d="M9 17h6" />
    <circle cx="17" cy="17" r="2" />
  </g>
</svg>
`
  },
  {
    title: 'Consumer products',
    desc: 'High-quality, aesthetically pleasing machined parts for everyday consumer devices, ensuring durability, precision, and premium surface finishes.',
    // 3D立体产品盒
    iconSvg: `<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
  <path d="M0 0h24v24H0z" fill="none" />
  <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 14v4a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2zm0 0v-3c0-2.333 2.4-7 8-7s8 4.667 8 7v3m0 0v4a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2z" />
</svg>
`
  },
  {
    title: 'Medical',
    desc: 'We have extensive experience in manufacturing artificial joints, bone screws, and precision medical parts.',
    // 六边形加医疗十字
    iconSvg: `<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
  <path d="M0 0h24v24H0z" fill="none" />
  <g fill="none">
    <path d="m12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035q-.016-.005-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093q.019.005.029-.008l.004-.014l-.034-.614q-.005-.018-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z" />
    <path fill="currentColor" d="M15 2a2 2 0 0 1 2 2v5h2a2 2 0 0 1 2 2v9.9a1.1 1.1 0 0 1-1.1 1.1H4.1A1.1 1.1 0 0 1 3 20.9V4a2 2 0 0 1 2-2zm0 2H5v16h2v-3a3 3 0 1 1 6 0v3h2zm4 7h-2v9h2zm-9 5a1 1 0 0 0-.993.883L9 17v3h2v-3a1 1 0 0 0-1-1m0-10a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0v-1H8a1 1 0 0 1 0-2h1V7a1 1 0 0 1 1-1" />
  </g>
</svg>
`
  },
  {
    title: 'Robotics',
    desc: 'Custom robot parts with tight tolerances for smooth movement and high efficiency. We specialize in machining high-rigidity and high-precision robot components.',
    // 工业机器人头部轮廓
    iconSvg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="8" width="16" height="12" rx="2"></rect><path d="M2 14h2"></path><path d="M20 14h2"></path><path d="M15 13v2"></path><path d="M9 13v2"></path><path d="M12 8V4l-2-2"></path></svg>`
  },
  {
    title: 'Electronics',
    desc: 'We produce miniature, high-accuracy parts for electronics, such as connectors and heat sinks, ensuring device reliability.',
    // 电子波段/示波器线
    iconSvg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline></svg>`
  },
  {
    title: 'Semiconductor',
    desc: 'Ultra-precision machining for semiconductor manufacturing equipment, meeting strict cleanroom standards and extremely tight tolerance requirements.',
    // 芯片晶圆/处理器
    iconSvg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="4" width="16" height="16" rx="2" ry="2"></rect><path d="M9 9h6v6H9z"></path><path d="M9 1V4"></path><path d="M15 1V4"></path><path d="M9 20V23"></path><path d="M15 20V23"></path><path d="M20 9h3"></path><path d="M20 14h3"></path><path d="M1 9h3"></path><path d="M1 14h3"></path></svg>`
  },
  {
    title: 'New Energy',
    desc: 'Advanced manufacturing solutions for renewable energy systems, including high-efficiency solar, wind, and battery storage components.',
    // 新能源电池组件
    iconSvg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="7" width="16" height="10" rx="2" ry="2"></rect><line x1="22" y1="11" x2="22" y2="13"></line><polygon points="11 7 8 12 11 12 9 17 14 11 11 11 13 7"></polygon></svg>`
  }
]);
</script>

<style scoped>
/* 基础背景 */
.industries-section {
  background: linear-gradient(180deg, #16bc9c 0%, #4ecdb3 40%, #e6f2f0 100%);
  padding: 80px 20px;
  min-height: 100vh;
  position: relative;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  margin-top: 20px;
}

/* 核心容器 */
.container {
  max-width: 1200px;
  margin: 0 auto;
  display: block !important; 
  width: 100%;
}

/* 头部文本区域 */
.header {
  width: 100%;
  margin-bottom: 50px;
  color: #ffffff;
  text-align: center; 
}

.header h2 {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 15px;
}

.header p {
  font-size: 1rem;
  line-height: 1.5;
  max-width: 550px;
  margin: 0 auto; 
  opacity: 0.9;
}

/* 卡片排版：8 个卡片，桌面端一行 4 个 */
.cards-wrapper {
  display: flex;
  flex-wrap: wrap; 
  gap: 20px;
  justify-content: center; 
}

.card {
  background-color: #ffffff;
  border-radius: 8px;
  padding: 12px;
  width: calc(25% - 15px); /* 4 列 */
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.05);
  min-width: 0; 
}

.card-inner {
  border: 1px solid #f0f0f5;
  border-radius: 8px;
  padding: 30px 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

/* 图标圆形背景 */
.icon-container {
  width: 60px;
  height: 60px;
  background-color: #f2f5fb;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 25px;
  color: #12987e; 
}

/* 控制 SVG 图标的大小 */
.icon-container :deep(svg) {
  width: 28px;
  height: 28px;
}

.card-inner h3 {
  color: #0a1b3f;
  font-size: 1.1rem;
  font-weight: 700;
  margin-bottom: 15px;
}

.card-inner p {
  color: #828a9a;
  font-size: 0.85rem;
  line-height: 1.6;
}

/* ==============================
   响应式适配
   ============================== */

/* ★ 关键修改：从 1024px 开始（包含 iPad 及以下），强制变为 2 列（双列） */
@media (max-width: 1024px) {
  .card {
    width: calc(50% - 10px); 
  }
}

/* 非常小的手机屏幕（可选，通常保留单列体验更好） */
@media (max-width: 767px) {
  .card {
    width: 100%; /* 单列 */
  }
}
</style>